module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1055-af41119bdf23559c206ba02eea40ae02.png";